<section class="gallery">

    <img class="epk-photo" src="https://res.cloudinary.com/dadqp2oia/image/upload/v1629671571/Music%20Website/ElyzaBleau-guitar-cemetery-lowRes_gv7awf.png" alt="portrait of Elyza with guitar in a cemetery">
    <img class="epk-photo two" src="https://res.cloudinary.com/dadqp2oia/image/upload/v1629671571/Music%20Website/ElyzaBleau-seatedSmile-lowRes_hkbq9d.png" alt="portrait of Elyza seated smiling">
    <img class="epk-photo two" src="https://res.cloudinary.com/dadqp2oia/image/upload/v1629671571/Music%20Website/ElyzaBleau-PortraitWhileFilming-lowRes_hi4hen.png" alt="portrait of Elyza while filming">

</section>
